import React, { useState, useEffect } from "react";
import {
  Container,
  ContainerView,
  TitlePage,
} from "../../components/Container";
import FormButton from "../../components/FormCustom2/Button";
import {
  itemDetail,
  animations,
  claimGift,
  queryGift,
  querySubscription,
} from "../../services/app";
import { useApp } from "../../contexts";
import { useWindowSize } from "../../hook/useWindowSize";
import { ArrowDownIcon } from "../../components/Icons/ArrowDownIcon";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { roundNumber } from "../../services/app";
import CardGift from "./components/CardGift";
import * as Notification from "../../Notification";
import Ar3DViewer from "../../components/Ar3dViewer";
import { TabSwiper } from "./components/TabSwiper";

export const TabPurchaseOption = {
  mall: "mall",
  app: "app",
  market: "market",
};

export const ClaimGift = () => {
  const {
    T: t,
    user,
    setLoading,
    language,
    convertToLocalCurrency,
    formatLocalCurrency,
    getCurrency,
    claimData,
    setPrePosition,
  } = useApp();
  const size = useWindowSize();
  const isMobile = size.width <= 1024 ? true : false;
  const DEFAUTL_OPTION = [
    {
      value: 99,
      label: t("All"),
    },
  ];

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const back = () => navigate(-1);
  const [cloudinaryInfo, setCloudinaryInfo] = useState(null);
  const [checkedAll, setCheckedAll] = useState(false);
  const [value, setValue] = useState(99);
  const [maxSubClaim, setMaxSubClaim] = useState(null);
  const [giftSelected, setGiftSelected] = useState([]);
  const [giftsSelected, setGiftsSelected] = useState({});
  const [claimedAvatar, setClaimedAvatar] = useState(null);
  const [items, setItems] = useState([]);
  const [itemIds, setItemIds] = useState([]);
  const [allGift, setAllGift] = useState([]);

  const [randomClass, setRandomClass] = useState("");
  const [renderCategory, setRenderCategory] = useState([]);

  useEffect(() => {
    if (value == 99) {
      if (items.length > 0) {
        setGiftsSelected(items[0]);
      }
    }else{
      const firstItem = items?.find((item) => item.animation_id.includes(value));
      if (firstItem) {
        setGiftsSelected(firstItem);
      }
    }
    
  }, [items]);

  const getRandomClass = (itemId) => {
    const arr = Array.from({ length: 7 }, (_, i) => i + 1);
    const random = itemId % 7;
    return `suzu-card-image-${arr[random]}`;
  }

  useEffect(() => {
    let data = giftSelected.map((x) => x.id);
    setItemIds(data);
  }, [giftSelected]);
  useEffect(() => {
    querySubscription().then(async (res) => {
      const giftData = res.data?.data;
      setMaxSubClaim(giftData.maxAvatar)
      setClaimedAvatar(giftData.giftIdsClaimed);
      if (giftData.maxAvatar && giftData.giftClaimedNumber > giftData.maxAvatar)
        return;
      const result = await Promise.all([loadData({ animationId: value, excludeIds: giftData.giftIdsClaimed }), animations()]);
      const dataItems = result[0];
      setItems(dataItems.rows);
      setAllGift(dataItems.rows);
      const renderCategory = (result[1]?.data?.data?.data || []).map((item) => {
        return {
          label: t(`${item.name}`),
          value: item.id,
        };
      });
      setRenderCategory([ ...DEFAUTL_OPTION, ...renderCategory]);
    });
    setPrePosition('subscription')
  }, []);

  const loadData = async ({ animationId, excludeIds }) => {
    setLoading(true);
    const result = await queryGift({
      page: 1,
      size: 50,
      animationIds: animationId == 99 ? [] : [animationId],
      excludeIds: excludeIds,
    });
    setLoading(false);
    return {
      rows: result.data?.data?.items?.rows || [],
      count: result.data?.data?.items?.count || 0,
    };
    
  };

  const handleChange = (newValue) => {
    setValue(newValue);
    loadData({ animationId: newValue, excludeIds: claimedAvatar }).then(
      (result) => {
        setItems(result.rows || []);
      }
    );
  };
  const handleSetCloudinaryInfo = (data) => {
    setCloudinaryInfo(null);
    setTimeout(() => {
      setCloudinaryInfo(data);
    });
  };
  useEffect(() => {
    if (giftsSelected?.img_info) {
      handleSetCloudinaryInfo(giftsSelected?.img_info);
    }
  }, [giftsSelected]);

  const handleChangePreview = (val) => {
    setGiftsSelected(val);
  };

  const handleSelectItem = (val) => {
    setGiftSelected(val);
  };
  const handleCheckedAll = () => {
    if (checkedAll) {
      setCheckedAll(false);
      setGiftSelected([]);
    } else {
      setCheckedAll(true);
      if (items.length == 0) return;
      setGiftSelected(allGift);
    }
  };

  const handleClickSelected = () => {
    if (giftSelected.length == 0) {
      Notification.error(t("Please select all avatars"));
      return;
    } else {
      claimGift({itemIds: itemIds})
        .then((res) => {
          if (res?.data?.error?.status) {
            Notification.success(t("Successfully claimed avatar"))
          }else{
            Notification.error(t("Fail to claim avatar"));
          }
          
        })
        .catch((error) => {
          Notification.error(t("Fail to claim avatar"));
        });
      navigate("/asset?type=subscription");
    }
  };

  return (
    <Container>
      <ContainerView background="transparent">
        <div className="flex justify-start gap-3 items-center">
          <div onClick={() => back()}>
            <ArrowDownIcon className="rotate-90 w-[24px] h-[24px] cursor-pointer stroke-black" />
          </div>
          <TitlePage>{t("Claim avatar")}</TitlePage>
        </div>
        <div className="flex flex-wrap lg:flex-nowrap justify-start items-start lg:gap-[50px]  mt-[30px] xls:mt-[40px]">
          <div className="w-full lg:w-[calc(100%-530px)] mb-[23px] lg:mb-[0]">
            <div className="item-detail-img-shadow max-h-[450px] w-full lg:max-h-[calc(100vh-270px)] aspect-[640/650] lg:py-[30px] rounded-[28px] bg-white">
              <div
                className={`w-full ${getRandomClass(
                  giftsSelected.id
                )} p-[5px] rounded-[16px] lg:rounded-none h-full item-image-inner`}
              >
                {cloudinaryInfo ? (
                  <Ar3DViewer
                    showZoom={false}
                    style={{
                      width: "100%",
                      height: isMobile ? 330 : "100%",
                      minHeight: "450px",
                      position: "relative",
                      padding: isMobile ? "0" : "0",
                      boxShadow: "none",
                    }}
                    publicId={cloudinaryInfo?.public_id}
                    cloudinaryInfo={cloudinaryInfo}
                  />
                ) : (
                  <div className="w-full h-full lg:h-full rounded-md bg-transparent lg:bg-white shadow-sm"></div>
                )}
              </div>
            </div>
          </div>
          <div className="w-full lg:w-[460px]">
            <div className="text-[14px] lg:text-[20px] text-black font-medium mb-[20px]">
              {t("Avatar pack for subscriber")}
            </div>
            <div className="">
              <TabSwiper
                options={renderCategory}
                onChange={handleChange}
                t={t}
              />
              {allGift.length > 0 && value == 99 && !maxSubClaim && (
                <div
                  className={`flex mt-[15px] lg:mx-0 space-x-3 mb-[20px] items-center cursor-pointer`}
                  onClick={() => handleCheckedAll()}
                >
                  {checkedAll ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                    >
                      <rect
                        x="1.33984"
                        y="0.5"
                        width="19"
                        height="19"
                        rx="4.5"
                        fill="white"
                        fillOpacity="0.2"
                        stroke="#000000"
                      />
                      <path
                        d="M17.4235 6.375L9.40267 14.3958L5.75684 10.75"
                        stroke="url(#paint0_linear_3618_31521)"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_3618_31521"
                          x1="5.75684"
                          y1="10.3857"
                          x2="17.4241"
                          y2="10.3857"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#E5665B" />
                          <stop offset="0.00022375" stop-color="#E5665B" />
                          <stop offset="0.2" stop-color="#BC2DBD" />
                          <stop offset="0.201284" stop-color="#BC2DBD" />
                          <stop offset="0.51" stop-color="#5F00A7" />
                          <stop offset="0.512073" stop-color="#5F00A7" />
                          <stop offset="0.72" stop-color="#393DB8" />
                          <stop offset="0.720835" stop-color="#393DB8" />
                          <stop offset="1" stop-color="#048ACC" />
                        </linearGradient>
                      </defs>
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <rect
                        x="0.5"
                        y="0.5"
                        width="19"
                        height="19"
                        rx="4.5"
                        fill="white"
                        fillOpacity="0.2"
                        stroke="#000000"
                      />
                    </svg>
                  )}{" "}
                  <span className="text-black">{t("Select All")}</span>
                </div>
              )}
              <div
                className="list-option-item-3d mt-[12px] lg:px-0"
                style={{
                  maxHeight: isMobile ? "calc(100vh - 500px)" : "460px",
                  overflowY: "auto",
                }}
              >
                <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-3 lg:gap-[8px] gap-[12px]  ml-auto overflow-y-auto">
                  {items.length > 0 &&
                    items.map((item, index) => (
                      <>
                        <CardGift
                          subClass={`${getRandomClass(item.id)} !bg-cover`}
                          key={item.id}
                          t={t}
                          amountSelected={giftSelected.length}
                          maximumAvatar={
                            maxSubClaim
                              ? maxSubClaim - claimedAvatar.length
                              : allGift.length
                          }
                          url={item.img}
                          index={index}
                          handleChangePreview={handleChangePreview}
                          handleSelectItem={handleSelectItem}
                          giftSelected={giftSelected}
                          item={item}
                        />
                      </>
                    ))}
                  {allGift.length == 0 && (
                    <div className="col-span-3 text-center text-black text-[16px]">
                      {t("You've claimed all available avatars")}
                    </div>
                  )}
                </div>
              </div>
              <div className="mt-[30px] lg:mt-[25px] flex  w-full justify-end px-[16px] lg:pr-0 lg:pl-0 lg:justify-center gap-[18px]">
                <FormButton
                  className={"primary2 w-full md:w-auto"}
                  style={{
                    width: "100%",
                    color: "white",
                    borderRadius: "14px",
                    fontWeight: 700,
                    height: isMobile ? 46 : 52,
                    padding: "4px 4px",
                    fontSize: 16,
                    opacity: allGift.length == 0 ? 0.7 : 1,
                  }}
                  disabled={allGift.length == 0}
                  onClick={() => handleClickSelected()}
                >
                  {t("Claim all")} ({giftSelected?.length}/
                  {maxSubClaim === null
                    ? allGift?.length
                      ? allGift?.length - claimedAvatar.length
                      : 0
                    : maxSubClaim > claimedAvatar.length ? maxSubClaim - claimedAvatar.length : 0}
                  )
                </FormButton>
              </div>
            </div>
          </div>
        </div>
      </ContainerView>
    </Container>
  );
};
